
import { defineComponent, ref, watchEffect } from "vue";
import { ErrorMessage, Field } from "vee-validate";
import { useStore } from "vuex";
import DropDownSection from "@/components/sections/DropDownSections.vue";

interface IStep4 {
  q4_1: string;
  q4_2: string;
}

export default defineComponent({
  name: "step-2",
  components: {
    Field,
    ErrorMessage,
    DropDownSection,
  },
  setup() {
    const store = useStore();
    const listDropDownSections = [
         {title: "Information", descriptions: [{description:
          " Some Information" }
        ]},
         
    ];

    const step3 = ref<IStep4>({
      q4_1: "",
      q4_2: "",
    });

    const submitButtonRef = ref<null | HTMLButtonElement>(null);

    const submit = () => {
      if (!submitButtonRef.value) {
        return;
      }
    };

    watchEffect(() => {
      const data = store.getters.currentSubject;

      if (data === null || data.data === undefined) return;
      step3.value.q4_1 = data.data.subjectLocation != undefined && data.data.subjectLocation != null? data.data.subjectLocation :"";
      step3.value.q4_2 = data.data.subRecruitedOther != undefined && data.data.subRecruitedOther != null? data.data.subRecruitedOther : "";
    });

    return {
      submit,
      submitButtonRef,
      step3,
      listDropDownSections,
    };
  },
});
